<template>
  <v-sheet color="primary_light_4">
    <v-container class="py-12">
      <v-row>
        <v-col cols="2">
          <v-card tile elevation="0" href="https://www.tsvs.org/">
            <v-img src="http://fakeimg.pl/140x60/"></v-img>
          </v-card>
        </v-col>
        <v-col cols="2">
          <v-card tile elevation="0" href="https://www.tsvs.org/">
            <v-img src="http://fakeimg.pl/140x60/"></v-img>
          </v-card>
        </v-col>
        <v-col cols="2">
          <v-card tile elevation="0" href="https://www.tsvs.org/">
            <v-img src="http://fakeimg.pl/140x60/"></v-img>
          </v-card>
        </v-col>
        <v-col cols="2">
          <v-card tile elevation="0" href="https://www.tsvs.org/">
            <v-img src="http://fakeimg.pl/140x60/"></v-img>
          </v-card>
        </v-col>
        <v-col cols="2">
          <v-card tile elevation="0" href="https://www.tsvs.org/">
            <v-img src="http://fakeimg.pl/140x60/"></v-img>
          </v-card>
        </v-col>
        <v-col cols="2">
          <v-card tile elevation="0" href="https://www.tsvs.org/">
            <v-img src="http://fakeimg.pl/140x60/"></v-img>
          </v-card>
        </v-col>
        <v-col cols="2">
          <v-card tile elevation="0" href="https://www.tsvs.org/">
            <v-img src="http://fakeimg.pl/140x60/"></v-img>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </v-sheet>
</template>

<script>
export default {
  name: "HomeLink"
};
</script>

<style></style>
